<template>
  <categories-button
    v-if="!$vuetify.display.mobile && !showCategories"
    @click="setShowCategories"
  />
</template>

<script setup lang="ts">
import CategoriesButton from '@/components/CategoriesButton.vue'
import useCategories from '@/modules/categories/useCategories'
import { storeToRefs } from 'pinia'

const { showCategories } = storeToRefs(useCategories())
const setShowCategories = () => (useCategories().showCategories = true)
</script>
